import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";

import App from "./App";

// Normaliza o modo embed ANTES do React montar. O sessionStorage é COMPARTILHADO
// entre os iframes de mesma origem (aba Administrador e aba Tickets no ERP), então
// o flag da última aba vazava. Ao entrar sempre por /sso, aqui o flag é acertado
// pelo ?embed da URL antes de qualquer render — sem race com Route/Layout/Dashboard.
try {
  if (window.location.pathname === "/sso") {
    const isEmbed =
      new URLSearchParams(window.location.search).get("embed") === "1";
    if (isEmbed) sessionStorage.setItem("whaticketEmbed", "1");
    else sessionStorage.removeItem("whaticketEmbed");
  }
} catch (e) {
  /* sessionStorage indisponível — ignora */
}

ReactDOM.render(
  <CssBaseline>
    <App />
  </CssBaseline>,
  document.getElementById("root"),
);

// ReactDOM.render(
// 	<React.StrictMode>
// 		<CssBaseline>
// 			<App />
// 		</CssBaseline>,
//   </React.StrictMode>

// 	document.getElementById("root")
// );
